import { currencyText } from '@/common/app/currency'
import { w2MasterEditPath } from '@/common/app/path'
import { dateTimeStr } from '@/common/form/date'
import { W2MasterData, W2Product } from '@/common/model/master/w2Master'

import TextButton from '@/components/view/atoms/button/TextButton'
import CheckBox from '@/components/view/atoms/checkbox/CheckBox'
import ClickableTableRow from '@/components/view/atoms/table/ClickableTableRow'
import TableRowItem from '@/components/view/atoms/table/TableRowItem'
import Text from '@/components/view/atoms/text/Text'

interface Props {
  item: W2MasterData
  selected: boolean
  onSelect(): void
  isScrolled: boolean
}

const W2ProductListRow = ({ item, selected, onSelect, isScrolled }: Props) => {
  const product = item.data as W2Product
  return (
    <ClickableTableRow href={w2MasterEditPath(item.site_id, item.master_type, item.id)}>
      <TableRowItem checkbox sticky={0} width={40}>
        <CheckBox name={'productId'} checked={selected} onChange={() => onSelect()} />
      </TableRowItem>
      <TableRowItem scrollShadow={isScrolled} width={88}>
        <Text size={14}>{product.shop_id}</Text>
      </TableRowItem>
      <TableRowItem width={128}>
        <Text size={14}>{product.product_id}</Text>
      </TableRowItem>
      <TableRowItem width={128}>
        <TextButton link={w2MasterEditPath(item.site_id, item.master_type, item.id)}>
          {product.name}
        </TextButton>
      </TableRowItem>
      <TableRowItem width={128}>
        <Text size={14}>{currencyText(product.display_price)}</Text>
      </TableRowItem>
      <TableRowItem width={128}>
        <Text size={14}>{product.category_id1}</Text>
      </TableRowItem>
      <TableRowItem width={128}>
        <Text size={14}>{product.brand_id1}</Text>
      </TableRowItem>
      <TableRowItem width={88}>
        <Text size={14}>{product.fixed_purchase_flg ? '○' : '×'}</Text>
      </TableRowItem>
      <TableRowItem width={88}>
        <Text size={14}>{product.valid_flg ? '○' : '×'}</Text>
      </TableRowItem>
      <TableRowItem width={88}>
        <Text size={14}>{product.del_flg ? '○' : '×'}</Text>
      </TableRowItem>
      <TableRowItem width={160}>
        <Text size={14}>{dateTimeStr(product.date_created)}</Text>
      </TableRowItem>
    </ClickableTableRow>
  )
}

export default W2ProductListRow
